var app             = require('./app'),
    bankDetails     = require('./bankDetails'),
    booking         = require('./booking'),
    centreFinder    = require('./centreFinder'),
    directDebitPage = require('./directDebitPage'),
    discounts       = require('./discounts'),
    faqs            = require('./faqs'),
    lessons         = require('./lessons'),
    liveChat        = require('./liveChat'),
    memberships     = require('./memberships'),
    payments        = require('./payments'),
    personalDetails = require('./personalDetails'),
    restrictions    = require('./restrictions'),
    selections      = require('./selections'),
    salesLines      = require('./salesLines'),
    siteBanding     = require('./siteBanding'),
    saveSelections  = require('./saveSelections'),
    staffLogin      = require('./staffLogin'),
    staffSearch     = require('./staffSearch'),
    stages          = require('./stages'),
    testimonials    = require('./testimonials'),
    user            = require('./user'),
    discountCodes   = require('./discountCodes');

module.exports = {
    app: app,
    bankDetails: bankDetails,
    booking: booking,
    centreFinder: centreFinder,
    directDebitPage: directDebitPage,
    discounts: discounts,
    discountCodes: discountCodes,
    faqs: faqs,
    lessons: lessons,
    liveChat: liveChat,
    memberships: memberships,
    payments: payments,
    personalDetails: personalDetails,
    restrictions: restrictions,
    siteBanding,
    selections: selections,
    salesLines: salesLines,
    saveSelections: saveSelections,
    staffLogin: staffLogin,
    staffSearch: staffSearch,
    stages: stages,
    testimonials: testimonials,
    user: user
};
